import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { ControlTowerState } from './control-tower.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([ControlTowerState])],
  declarations: []
})
export class ControlTowerModule {}
